import { useState, useEffect } from 'react';
import { isBrowser } from 'ws-scripts/modules/environment';

/**
 * This hook reads `enableMyCars` from `window.DDC.siteProperties`, a client-only
 * global that is not part of the SSR payload today (the site prop could instead
 * be fetched server-side and seeded, which would remove the need for the
 * two-pass read below). Reading it during render is unsafe for SSR + hydration:
 * `isBrowser` is a build-time constant (false in the node/SSR build, true in the
 * browser build), so a render-time read resolves to `false` on the server render
 * and `true` on the client's first (hydration) render. That flips the footer's
 * CTA set and its layout classNames (via useFooterCTAs -> useFooterLayoutClasses
 * and the direct checks in FooterContainer), producing a React hydration
 * mismatch on My-Cars-enabled sites.
 *
 * Fix: defer the read to a post-mount effect (two-pass render). The first client
 * render returns the same value the server produced (`false`), so hydration
 * matches; once mounted, the effect reads the real value and re-renders. The
 * only visible effect is a one-frame settle of the footer on My-Cars sites,
 * which is acceptable versus a hydration mismatch.
 */
export const useMyCarsSiteProperties = () => {
	const [enableMyCars, setEnableMyCars] = useState(false);

	useEffect(() => {
		if (isBrowser) {
			setEnableMyCars(
				Boolean(window?.DDC?.siteProperties?.enableMyCars === 'true')
			);
		}
	}, []);

	return {
		enableMyCars
	};
};
